import PageSeo from '@framework/seo/PageSeo';
import MetaSchema from '@/creditflowresearch/ui/common/components/MetaSchema/MetaSchema';
import { Product, CorporateProduct } from '@/creditflowresearch/domain/Product';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import BetaTitle from '@/creditflowresearch/ui/common/components/Title/BetaTitle';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import ProductPageHeader from '@/creditflowresearch/ui/common/components/templates/ProductPageHeader';
import { useProductGradient } from '@/creditflowresearch/ui/common/hooks/products/useProductGradient';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';

interface IScorecardHeaderProps {
  title: string,
  description: string,
  companyName?: string,
  checks: boolean[],
  isPageLoading: boolean,
}

const ScorecardHeader = ({
  title,
  description,
  companyName,
  checks,
  isPageLoading,
}: IScorecardHeaderProps) => {
  const {
    includedProductIds,
    regionFilters,
    corporateProductFilters,
  } = usePageFiltersContext();
  const { checkAccessByUserPlan } = useUserPlanContext();
  const panelBackground = useProductGradient();

  return (
    <>
      <MetaSchema />
      <PageSeo title={ title } description={ description } />
      <ProductPageHeader
        title={ (
          <BetaTitle
            title={ `${ companyName } League Table` }
            showBeta={ !Product.areAllOfType(includedProductIds, AbsProduct.TYPE) }
          />
        ) }
        items={ [
          {
            key: 'regions',
            items: regionFilters,
          },
          {
            key: 'products',
            items: corporateProductFilters,
            isVisible: Product.areAllOfTypes(includedProductIds, CorporateProduct.CORPORATE_TYPES),
          },
        ] }
        accessConditions={ [{ checks }] }
        blockingAccessConditions={ [{ checks: [checkAccessByUserPlan(UserPlanType.STARTER)] }] }
        isDisabled={ isPageLoading }
        panelBackground={ panelBackground }
      />
    </>
);
};

export default ScorecardHeader;
